var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayoutGridLine = function SvgLayoutGridLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.75 3.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H3.25A.75.75 0 0 1 2.5 16V4a.75.75 0 0 1 .75-.75zm-7.5 7.5H4v4.5h5.25zm6.75 0h-5.25v4.5H16zm-6.75-6H4v4.5h5.25zm6.75 0h-5.25v4.5H16z"
  })));
};
export default SvgLayoutGridLine;